import AnnouncementPage from 'app/BCKSPage/AnnouncementPage'
import MaintenanceModePage from 'app/BCKSPage/MaintenanceMode'
import { isToggleEnabled } from 'configs/toggle-feature'

interface PropsAnnouncementPage {
  isKSSelectionEnabled: boolean
}

export async function getServerSideProps() {
  const isKSSelectionEnabled = await isToggleEnabled('ks-selection-enabled')

  return {
    props: {
      isKSSelectionEnabled,
    },
  }
}

const AnnouncementPageIndex = (props: PropsAnnouncementPage) => {
  if (!props.isKSSelectionEnabled) {
    return <MaintenanceModePage />
  }

  return <AnnouncementPage />
}

// eslint-disable-next-line react/display-name
AnnouncementPageIndex.Layout = ({ children }) => children

export default AnnouncementPageIndex
